// 공용 배지.
// 주문 상태/적립/수량 등 짧은 라벨을 의미색 토큰으로 표시한다.
// tone 으로 의미를 분리해 화면마다 임시 색(red/green/amber)을 직접 쓰지 않게 한다.

import type { ReactNode } from "react";
import { cn } from "./cn.ts";

type Tone = "brand" | "neutral" | "success" | "warning" | "danger";

interface BadgeProps {
  tone?: Tone;
  className?: string;
  children: ReactNode;
}

// tone 별 배경/글자: 연한 배경 + 진한 글자(대비 확보).
const toneClass: Record<Tone, string> = {
  brand: "bg-brand-50 text-brand-700",
  neutral: "bg-ink-100 text-ink-700",
  success: "bg-success-50 text-success-700",
  warning: "bg-warning-50 text-warning-700",
  danger: "bg-danger-50 text-danger-700",
};

// 주문 상태/적립/수량 등 짧은 라벨을 의미색 토큰으로 표시하는 공용 배지.
export default function Badge({ tone = "neutral", className, children }: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold",
        toneClass[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
